import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModel } from './base';
import { EModel } from './model';
export let ENamespace;
(function (ENamespace) {
  ENamespace["AppointmentsCancel"] = "api:appointments:cancel";
  ENamespace["AvailabilitiesUpdate"] = "api:availabilities:update";
  ENamespace["BroadcastsCreate"] = "api:broadcasts:create";
  ENamespace["BroadcastsUpdate"] = "api:broadcasts:update";
  ENamespace["FeedbackResponsesCreate"] = "api:feedbackResponses:create";
  ENamespace["FeedbackResponsesCreateFromIntents"] = "api:feedbackResponses:createFromIntents";
  ENamespace["InsurancesCreate"] = "api:insurances:create";
  ENamespace["InsurancesUpdate"] = "api:insurances:update";
  ENamespace["OffersCreate"] = "api:offers:create";
  ENamespace["OffersAccept"] = "api:offers:accept";
  ENamespace["OffersCancel"] = "api:offers:cancel";
  ENamespace["OffersUpdate"] = "api:offers:update";
  ENamespace["OutboundReferralsCreate"] = "api:outboundReferrals:create";
  ENamespace["OutboundReferralsUpdate"] = "api:outboundReferrals:update";
  ENamespace["PatientFormsCreate"] = "api:patientForms:create";
  ENamespace["PatientFormsUpdate"] = "api:patientForms:update";
  ENamespace["ReferralsUpdate"] = "api:referrals:update";
  ENamespace["ReferralsCreate"] = "api:referrals:create";
  ENamespace["TelehealthsUpdate"] = "api:telehealths:update";
  ENamespace["UserSignup"] = "api:users:signup";
  ENamespace["WaitlistsCreate"] = "api:waitlists:create";
  ENamespace["LumabotFlowsNotifyAnswer"] = "api:lumabotFlows:notifyAnswer";
})(ENamespace || (ENamespace = {}));
export let EActivityType;
(function (EActivityType) {
  EActivityType["Appointments"] = "appointments";
  EActivityType["Availabilities"] = "availabilities";
  EActivityType["Broadcasts"] = "broadcasts";
  EActivityType["BroadcastsPending"] = "broadcasts:pending";
  EActivityType["FeedbackResponses"] = "feedbackResponses";
  EActivityType["Insurances"] = "insurances";
  EActivityType["LumabotFlows"] = "lumabotFlows";
  EActivityType["MessagesProviderPatientPinVerificationContactChanged"] = "messages:providerPatientPinVerificationContactChanged";
  EActivityType["Offers"] = "offers";
  EActivityType["OffersCancellation"] = "offers:cancellation";
  EActivityType["OffersFindOpenSpots"] = "offers:find-open-spots";
  EActivityType["OffersManual"] = "offers:manual";
  EActivityType["OffersReschedule"] = "offers:reschedule";
  EActivityType["OffersRescheduleFromIntent"] = "offers:reschedule-from-intent";
  EActivityType["OffersSelfScheduling"] = "offers:self-scheduling";
  EActivityType["OffersStaffScheduling"] = "offers:staff-scheduling";
  EActivityType["OutboundReferrals"] = "outboundReferrals";
  EActivityType["PatientForms"] = "patientForms";
  EActivityType["Referrals"] = "referrals";
  EActivityType["Telehealths"] = "telehealths";
  EActivityType["Users"] = "users";
  EActivityType["Waitlists"] = "waitlists";
})(EActivityType || (EActivityType = {}));
export let EActivityContextModel;
(function (EActivityContextModel) {
  EActivityContextModel["Appointments"] = "appointment";
  EActivityContextModel["Availabilities"] = "availability";
  EActivityContextModel["Broadcasts"] = "broadcast";
  EActivityContextModel["FeedbackResponses"] = "feedbackResponse";
  EActivityContextModel["Insurances"] = "insurance";
  EActivityContextModel["Offers"] = "offer";
  EActivityContextModel["OutboundReferrals"] = "outboundReferral";
  EActivityContextModel["PatientForms"] = "patientForm";
  EActivityContextModel["Referrals"] = "referral";
  EActivityContextModel["Telehealths"] = "telehealth";
  EActivityContextModel["Users"] = "user";
  EActivityContextModel["Waitlists"] = "waitlist";
  EActivityContextModel["LumabotFlows"] = "lumabotFlow";
})(EActivityContextModel || (EActivityContextModel = {}));
export const fieldsActivity = _extends({}, fieldsIBaseModel, {
  action: {
    type: 'Unknown'
  },
  actionTaken: {
    type: 'Boolean'
  },
  activityContext: {
    type: 'Object'
  },
  activityContextId: {
    type: 'Text'
  },
  activityContextModel: {
    type: 'Option',
    values: EActivityContextModel
  },
  activityContextVersion: {
    type: 'Number'
  },
  appointmentType: {
    type: 'ID',
    ref: EModel.AppointmentType
  },
  facility: {
    type: 'ID',
    ref: EModel.Facility
  },
  namespace: {
    type: 'Option',
    values: ENamespace
  },
  patient: {
    type: 'ID',
    ref: EModel.Patient
  },
  provider: {
    type: 'ID',
    ref: EModel.Provider
  },
  timestamp: {
    type: 'Date'
  },
  type: {
    type: 'Option',
    values: EActivityType
  }
});